import React from 'react'

const Events: React.FC = () => {
    return (
        <section className="page-section bg-light" id="portfolio">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase" style={{ color: '#000' }}>
                        Our Events
                    </h2>
                </div>

                <div data-tockify-component="calendar" data-tockify-calendar="houseevents"></div>
            </div>
        </section>
    )
}

export default Events
